import { resetSettingsRuntimeState } from '@/composables/use-settings';
import { resetPublicSettingsState } from '@/composables/use-public-settings';
import { reseedTranslationsAfterCacheClear, translations } from '@/composables/use-update-translations';
import { resetCustomStyleInjectionState } from '@/utils/custom-style-resources';
import { resetBootConfigSourceState } from '@/utils/boot-config-source';

/**
 * Clears in-memory settings/translations and stylesheet injection tracking.
 * Call alongside `clearHelixCache()` on logout so SPA state does not outlive the session.
 */
export function clearHelixRuntimeState(): void {
  resetSettingsRuntimeState();
  resetPublicSettingsState();

  for (const key of Object.keys(translations)) {
    delete translations[key];
  }

  reseedTranslationsAfterCacheClear();
  resetCustomStyleInjectionState();
  resetBootConfigSourceState();
}
